import { images } from "../../assets/images";


export const yourTools = [
  {
    id: "teach-this-topic",
    title: "Teach This Topic",
    iconSrc: images.yourTools[0],
    href: "#teach-this-topic",
  },
  {
    id: "quick-sheets",
    title: "Quick Sheets",
    iconSrc: images.yourTools[1],
    href: "#quick-sheets",
  },
  {
    id: "question-paper-generator",
    title: "Question Paper Generator",
    iconSrc: images.yourTools[2],
    href: "#question-paper-generator",
  },
];